<template>
  <div class="info-box column">
    <i
      class="el-icon-arrow-left"
      @click="toMy"
      style="margin-right: 10px; cursor: pointer"
    ></i>
    <div class="info-header row">
      <div class="title">アカウント情報</div>
    </div>
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="100px"
      class="form-box column"
    >
      <div class="column">
        <div class="form-item row m-column">
          <el-form-item label="お名前" prop="realname">
            <el-input
              v-model="ruleForm.realname"
              :disabled="false"
              placeholder="お名前を入力"
            ></el-input>
          </el-form-item>
          <el-form-item label="フリガナ (カタカナを入力)" prop="falsename">
            <el-input
              v-model="ruleForm.falsename"
              :disabled="false"
              placeholder="フリガナを入力"
            ></el-input>
          </el-form-item>
        </div>
        <div class="form-item row m-column">
          <el-form-item label="ニックネーム (全角8文字まで)" prop="nickname">
            <el-input
              v-model="ruleForm.nickname"
              placeholder="ニックネームを入力"
              maxlength="8"
            ></el-input>
          </el-form-item>
          <el-form-item label="性別" prop="sex" class="sex-box m-row">
            <el-radio-group v-model="ruleForm.sex" class="m-row">
              <el-radio-button
                v-for="(item, index) in sexBox"
                :key="index"
                :label="index"
                :value="index"
                name="sex"
                >{{ item }}</el-radio-button
              >
            </el-radio-group>
          </el-form-item>
        </div>
        <div class="form-item row m-column">
          <el-form-item>
            <div class="row m-row">
              <el-form-item
                label="生年月"
                prop="year"
                style="margin-right: 20px"
              >
                <el-select
                  v-model="ruleForm.year"
                  :disabled="false"
                  placeholder="年を選択してください"
                  class="birthday-year"
                >
                  <el-option label="年" value=""></el-option>
                  <el-option
                    v-for="index in 2022"
                    v-if="index >= 1900"
                    :key="index"
                    :label="index"
                    :value="index"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label=" " prop="month">
                <el-select
                  v-model="ruleForm.month"
                  :disabled="false"
                  placeholder="月を選択してください"
                  class="birthday-month"
                  @change="monthChange"
                >
                  <el-option label="月" value=""></el-option>
                  <el-option
                    v-for="index in 12"
                    v-if="index >= 1"
                    :key="index"
                    :label="index"
                    :value="index"
                  ></el-option>
                </el-select>
              </el-form-item>
            </div>
          </el-form-item>
          <el-form-item label="住所" prop="address">
            <el-select
              v-model="ruleForm.address"
              :disabled="false"
              placeholder="都道府県を選択"
              class="select-region"
            >
              <el-option label="選択してください" value=""></el-option>
              <el-option
                v-for="(item, index) in region"
                :key="index"
                :label="item"
                :value="item"
              ></el-option>
            </el-select>
          </el-form-item>
        </div>
        <div class="form-item row m-column">
          <el-form-item label="職業" prop="job">
            <el-select
              v-model="ruleForm.job"
              placeholder="職業を選択"
              class="select-job"
            >
              <el-option label="選択してください" value=""></el-option>
              <el-option
                v-for="(item, index) in job"
                :key="index"
                :label="item"
                :value="item"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="メールアドレス" prop="email">
            <el-input
              v-model="ruleForm.email"
              :disabled="socialType == 'google'"
              placeholder="メールアドレスを入力"
            ></el-input>
          </el-form-item>
        </div>
        <div
          class="form-item row m-column"
          v-if="!isSocial && socialType == null"
        >
          <el-form-item label="パスワード" class="password-btn-box column">
            <el-button class="change-password-btn" @click="changePass"
              >パスワードを変更</el-button
            >
          </el-form-item>
        </div>
      </div>
      <div class="btns-box row row-center">
        <el-button class="save-btn" @click="doSub('ruleForm')"
          >保存する</el-button
        >
      </div>
    </el-form>
    <el-dialog
      title="パスワードを変更"
      :visible.sync="dialogFormVisible"
      class="change-box"
    >
      <el-form :model="passForm" :rules="passRules" ref="passForm">
        <el-form-item label="元のパスワード" prop="oldpassword">
          <el-input
            v-model="passForm.oldpassword"
            show-password
            autocomplete="off"
            placeholder="元のパスワードを入力"
          ></el-input>
        </el-form-item>
        <el-form-item label="新しいパスワード" prop="password">
          <el-input
            v-model="passForm.password"
            show-password
            autocomplete="off"
            placeholder="新しいパスワードを入力"
          ></el-input>
        </el-form-item>
        <el-form-item label="新しいパスワード" prop="confirmpassword">
          <el-input
            v-model="passForm.confirmpassword"
            show-password
            autocomplete="off"
            placeholder="確認のため新しいパスワードを再入力"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer btns-box row row-center">
        <el-button class="save-btn" @click="doChangePass('passForm')"
          >変更する</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {
  getUserInfo,
  getUserInfoById,
  changPassword,
  editUserInfo,
} from "../../api/api.js";
export default {
  name: "app",
  data() {
    var passwordValidator = (rule, value, callback) => {
      if (value.length < 6) {
        callback(new Error("6文字以上のパスワードを入力"));
      } else {
        callback();
      }
    };
    var repasswordValidator = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("確認のためパスワードを再入力"));
      } else if (value !== this.passForm.password) {
        callback(new Error("パスワードが一致していません!"));
      } else {
        callback();
      }
    };
    return {
      region: this.GLOBAL.region,
      job: this.GLOBAL.job,
      sexBox: this.GLOBAL.sexBox,
      dialogFormVisible: false,
      choosedate: 30,
      // 表单规则
      ruleForm: {
        realname: "", // 姓名
        falsename: "", // 读音
        nickname: "", // 昵称
        sex: 0, // 性别
        year: "", // 生日年份
        month: "", // 生日月份
        day: "1", // 生日天
        birthday: "", // 生日
        address: "", // 住所
        job: "", // 職業
        email: "", // 邮箱
        password: "",
        repassword: "",
      },
      rules: {
        realname: [
          {
            required: true,
            message: "お名前を入力",
            trigger: "blur",
          },
          {
            validator: function (rule, value, callback) {
              //校验中文的正则：/^[\u4e00-\u9fa5]{0,}$/
              if (
                /^[\u30a0-\u30ff\u3040-\u309f\u3005-\u3006\u30e0-\u9fcf-\u0009\u0020\u00A0\u2002-\u200B\u3000\uFEFF]+$/.test(
                  value
                ) == true ||
                /^[a-zA-Z]+$/.test(value) == true ||
                /^[(?!."#$%&'()\*\+\-\.,\/:;<=>?@\[\\\]^_`{|}~)]+$/.test(
                  value
                ) == true ||
                value.trim().includes(" ") ||
                value.trim().includes(" ") ||
                value.trim().includes(" ")
              ) {
                callback();
              } else {
                //校验通过
                return callback(new Error("お名前を入力してください"));
              }
            },
            trigger: "blur",
          },
        ],
        falsename: [
          {
            required: true,
            message: "フリガナを入力",
            trigger: "blur",
          },
          {
            validator: function (rule, value, callback) {
              //校验中文的正则：/^[\u4e00-\u9fa5]{0,}$/
              if (
                /^[\u30A1-\u30F6\u30FC]+$/.test(value) == true ||
                /^ [\uFF66-\uFF9F]+$/.test(value) == true ||
                value.trim().includes(" ") ||
                value.trim().includes("　")
              ) {
                callback();
              } else {
                //校验通过
                return callback(new Error("カタカナを入力してください"));
              }
            },
            trigger: "blur",
          },
        ],
        nickname: [
          { required: true, message: "ニックネームを入力", trigger: "blur" },
        ],
        sex: [
          {
            required: true,
            message: "性別を選択してください",
            trigger: "change",
          },
        ],
        year: [
          {
            required: true,
            message: "年を選択してください",
            trigger: "change",
          },
        ],
        month: [
          {
            required: true,
            message: "月を選択してください",
            trigger: "change",
          },
        ],
        day: [
          {
            required: true,
            message: "日を選択してください",
            trigger: "change",
          },
        ],
        address: [
          {
            required: true,
            message: "都道府県を選択",
            trigger: "change",
          },
        ],
        job: [
          {
            required: true,
            message: "職業を選択",
            trigger: "change",
          },
        ],
        email: [
          {
            type: "email",
            required: true,
            message: "メールアドレスを入力",
            trigger: "blur",
          },
        ],
      },
      passForm: {
        oldpassword: "", // 旧密码
        password: "", // 新密码
        confirmpassword: "", // 确认新密码
      },
      passRules: {
        oldpassword: [
          { required: true, message: "元のパスワード", trigger: "blur" },
        ],
        password: [
          {
            required: true,
            message: "6文字以上のパスワードを入力",
            validator: passwordValidator,
            trigger: "blur",
          },
        ],
        confirmpassword: [
          {
            required: true,
            validator: repasswordValidator,
            message: "確認のためパスワードを再入力",
            trigger: "blur",
          },
        ],
      },
      id: "",
      isSocial: false,
      socialType: null,
    };
  },
  components: {},
  mounted() {
    this.getUserInfo();
  },
  methods: {
    monthChange(e) {
      console.log(e);
      let that = this;
      let year = that.ruleForm.year;
      if ((year % 100 != 0 && year % 4 == 0) || year % 400 == 0) {
        if (
          e == 1 ||
          e == 3 ||
          e == 5 ||
          e == 7 ||
          e == 8 ||
          e == 10 ||
          e == 12
        ) {
          that.choosedate = 31;
          return false;
        }
        if (e == 2) {
          that.choosedate = 29;
          return false;
        }
        if (e == 2 || e == 4 || e == 6 || e == 9 || e == 11) {
          that.choosedate = 30;
          return false;
        }
      } else {
        if (
          e == 1 ||
          e == 3 ||
          e == 5 ||
          e == 7 ||
          e == 8 ||
          e == 10 ||
          e == 12
        ) {
          that.choosedate = 31;
          return false;
        }
        if (e == 2) {
          that.choosedate = 28;
          return false;
        }
        if (e == 2 || e == 4 || e == 6 || e == 9 || e == 11) {
          that.choosedate = 30;
          return false;
        }
      }
    },
    getUserInfo: function () {
      // let that = this,
      //   token = localStorage.getItem("Authorization");
      // getUserInfo(token).then((res) => {
      //   if (res) {
      //     that.id = res.result.id;
      //     if(res.result.sex === null) {
      //       that.isSocial = true;
      //     }
      //     that.socialType = res.result.thirdType;

      //     that.ruleForm = {
      //       realname: that.isSocial ? ( that.socialType == 'google' ? '' :  res.result.realname) : res.result.realname, // 姓名
      //       falsename: res.result.falsename, // 读音
      //       nickname: that.isSocial ? '' : res.result.nickname, // 昵称
      //       sex: res.result.sex, // 性别
      //       year: res.result.year, // 生日年份
      //       month: res.result.month, // 生日月份
      //       day: res.result.day, // 生日天
      //       address: res.result.address, // 住所
      //       job: res.result.job, // 職業
      //       email: that.isSocial ? ( that.socialType == 'google' ? res.result.email :  '') : res.result.email, // 邮箱
      //     };
      //     console.log(that.socialType, that.ruleForm);
      //   }
      // });
      let that = this,
        userId = localStorage.getItem("homeowner");
      getUserInfoById(userId).then((res) => {
        console.log(res);
        if (res) {
          that.id = res.result.id;
          if (res.result.sex === null) {
            that.isSocial = true;
          }
          that.socialType = res.result.thirdType;
          let birthday = new Date(res.result.birthday);
          that.ruleForm = {
            realname: that.isSocial
              ? that.socialType == "google"
                ? ""
                : res.result.realname
              : res.result.realname, // 姓名
            falsename: res.result.falsename, // 读音
            nickname: that.isSocial ? "" : res.result.nickname, // 昵称
            sex: res.result.sex, // 性别
            year: birthday.getFullYear(), // 生日年份
            month: birthday.getMonth() + 1, // 生日月份
            day: 1, // 生日天
            address: res.result.address, // 住所
            job: res.result.job, // 職業
            email: that.isSocial
              ? that.socialType == "google"
                ? res.result.email
                : ""
              : res.result.email, // 邮箱
          };
        }
      });
    },
    changePass: function () {
      this.dialogFormVisible = true;
    },
    doChangePass: function (formName) {
      let that = this;
      let data = that.passForm;
      that.$refs[formName].validate((valid) => {
        if (valid) {
          let formData = {
            oldpassword: data.oldpassword,
            password: data.password,
            confirmpassword: data.confirmpassword,
          };
          changPassword(formData).then((res) => {
            console.log(res);
            if (res) {
              that.$message({
                message: "パスワードを再設定しました",
                type: "success",
                onClose: function () {
                  that.dialogFormVisible = false;
                },
              });
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    toMy: function () {
      this.$router.push("/my");
    },
    doSub: function (formName) {
      let that = this;
      let data = that.ruleForm;
      let email = data.email;
      console.log("www");
      var reg =
        /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
      if (reg.test(email)) {
        console.log("验证成功");
      } else {
        console.log("邮箱認証に失敗しました");
        return false;
      }
      console.log(that);

      that.$refs[formName].validate((valid) => {
        console.log("valid", valid);
        if (valid) {
          let formData = {
            id: that.id,
            realname: data.realname, // 姓名
            falsename: data.falsename, // 读音
            nickname: data.nickname, // 昵称
            sex: data.sex, // 性别
            birthday: data.year + "-" + data.month + "-" + data.day, // 生日
            address: data.address, // 住所
            job: data.job, // 職業
            email: data.email, // 邮箱
            password: data.password ? data.password : "", // 密码
          };
          console.log(formData);
          editUserInfo(formData).then((res) => {
            if (res.code == 200) {
              that.$message({
                message: "データは正しく保存されました",
                type: "success",
              });
              console.log(res);
              that.$router.push("/my");
            } else {
              if (res.message != null && res.message != "") {
                that.$message({
                  message: res.message,
                  type: "error",
                });
              }
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
  },
};
</script>

<style lang="css" scoped>
@import "../../assets/css/base.css";
.info-box {
  /* width: 696px; */
  /* height: 650px; */
  min-width: 300px;
  max-width: 700px;
  margin: 0 auto;
  margin-top: 10%;
  background: #fff;
  box-shadow: 0 10px 20px #63aeb0;
  border-radius: 24px;
  padding: 38px 42px;
  /* padding-bottom: 0; */
  position: relative;
}

.el-icon-arrow-left {
  position: absolute;
  top: -2.4rem;
  left: 1rem;
}
.info-box .info-header {
  height: 45px;
  line-height: 23px;
}
.info-box .info-header .el-icon-arrow-left {
  line-height: 25px;
  color: #83c3c5;
  font-weight: 900;
}
.info-box .info-header .title {
  font-weight: 700;
  font-size: 20px;
  color: #83c3c5;
}
.info-box .form-box {
  width: 100%;
  margin: 0 auto;
  color: #686868;
}
.info-box .form-item {
  justify-content: space-between;
}
.info-box .el-form-item {
  flex: 1;
  display: -webkit-flex;
  display: flex;
  flex-direction: column;
}
.info-box .el-form-item:nth-child(odd) {
  margin-right: 20px;
}
.info-box .el-form-item__label {
  text-align: left;
  line-height: 20px;
  width: auto !important;
  color: #434242 !important;
}
.info-box
  .el-form-item.is-required:not(.is-no-asterisk)
  .el-form-item__label-wrap
  > .el-form-item__label:before,
.info-box
  .el-form-item.is-required:not(.is-no-asterisk)
  > .el-form-item__label:before {
  content: "";
}
.el-form-item__content {
  margin-left: 0 !important;
}
.info-box .password-btn-box .el-form-item__label {
  flex: 2;
}
.info-box .password-btn-box .el-form-item__content {
  flex: 3;
}
.info-box .password-btn-box .change-password-btn {
  /* background: #83c3c5; */
  border: 1.5px solid #83c3c5;
  color: #83c3c5;
  border-radius: 8px;
  /* color: #fff; */
  /* height: 48px; */
}
/*  按钮  */
.info-box .btns-box {
  margin-top: 10px;
}
.info-box .btns-box button {
  width: 196px;
  height: 39px;
  line-height: 9px;
  border-radius: 8px;
  font-size: 14px;
  margin: 7px 0 !important;
}
.info-box .btns-box .save-btn {
  /* background: #83c3c5; */
  border: 1.5px solid #83c3c5;
  color: #83c3c5;
}

@media (max-width: 1024px) {
  .info-box .el-form-item:nth-child(odd) {
    margin-right: 0;
  }

  .info-box {
    padding: 2rem 1.5rem;
    min-width: 300px;
  }
}

@media (max-width: 460px) {
  .info-box {
    width: 90%;
    min-width: 300px;
    height: auto;
    margin-bottom: 3rem;
    padding: 1.5rem 1rem;
  }
  .info-box .form-box {
    width: 100%;
    margin: 0 auto;
    color: #686868;
  }
  .info-box .form-box div {
    width: 100%;
  }
}
</style>
<style>
.info-box .el-form-item__label {
  text-align: left;
  line-height: 20px;
  width: auto !important;
  color: #434242 !important;
}
.info-box .form-box .el-input__inner {
  height: 43px;
  margin: 8px auto;
  margin-bottom: 3px;
  border: 0;
  background: rgba(189, 189, 189, 0.18);
  border-radius: 8px;
  color: #686868;
}
.info-box .form-box .el-input.is-disabled .el-input__inner {
  background: rgba(77, 77, 77, 0.18);
  border-color: #e4e7ed;
  color: #686868;
  cursor: not-allowed;
}
.info-box .form-box .sex-box .el-radio-group {
  height: 43px;
  margin: 8px auto;
}
.info-box .form-box .sex-box .el-radio-button__inner {
  border-radius: 8px !important;
  background: rgba(189, 189, 189, 0.18);
  margin-left: 20px;
  /* width: 88px; */
  height: 43px;
  line-height: 20px;
  border: 0;
  color: #9c9c9c;
}
.info-box .form-box .sex-box .el-radio-button__inner:hover {
  color: #83c3c5;
}
.info-box
  .form-box
  .sex-box
  .el-radio-button:first-child
  .el-radio-button__inner {
  margin-left: 0;
  border-left: none;
}
.info-box
  .form-box
  .sex-box
  .el-radio-button__orig-radio:checked
  + .el-radio-button__inner {
  color: #686868;
  background: #4d4d4d2e;
  border-color: #4d4d4d2e;
  -webkit-box-shadow: -1px 0 0 0 #4d4d4d2e;
  box-shadow: -1px 0 0 0 #4d4d4d2e;
}
.info-box .el-checkbox__input.is-checked .el-checkbox__inner {
  background-color: #83c3c5;
  border-color: #83c3c5;
}
.info-box .el-checkbox__input.is-checked .el-checkbox__inner:hover {
  border-color: #83c3c5;
}
.info-box .el-input__suffix {
  height: 43px;
  margin: 8px 0;
  margin-bottom: 3px;
}
.info-box .select-region {
  width: 100%;
}

.info-box .select-job {
  width: 100%;
}

.info-box .birthday-box .el-form-item {
  margin-right: 0;
}
.info-box .birthday-year {
  /* width: 113px; */
}
.info-box .birthday-month,
.birthday-day {
  /* width: 82px;
  margin-left: 25px; */
}
.info-box .birthday-day {
  margin-right: 30px;
}

/*  弹窗  */
.info-box .el-dialog {
  width: 20rem;
  border-radius: 24px;
}
.info-box .el-dialog .el-dialog__header {
  text-align: center;
}
.info-box .el-dialog .el-dialog__header .el-dialog__title {
  font-weight: 700;
  font-size: 20px;
  line-height: 23px;
  color: #83c3c5 !important;
}
.info-box .el-dialog .el-dialog__body {
  padding: 10px 30px;
}
.info-box .el-dialog .el-dialog__body .el-form-item {
  margin-right: 0;
}
.info-box .el-dialog .el-dialog__body .el-form-item .el-input__suffix {
  margin: 0;
}

@media (max-width: 460px) {
  .info-box {
    width: 90%;
    min-width: 300px;
    height: auto;
    margin-bottom: 3rem;
    padding: 1rem 0.5rem;
  }
  .info-box .form-box {
    width: 100%;
    margin: 0 auto;
    color: #686868;
  }
  .info-box .form-box div {
    width: 100%;
  }
  .info-box .form-item {
    justify-content: space-between;
  }
  .info-box .form-item .el-form-item {
    margin-right: 0;
  }
  .info-box .form-box .el-input--suffix .el-input__inner {
    padding-right: 0;
  }
  .info-box .el-form-item {
    margin-bottom: 10px;
  }
  /*  性别选择  */
  .info-box .form-box .el-input__inner {
    margin: 0.5rem auto;
    margin-bottom: 3px;
  }
  .info-box .form-box .sex-box .el-radio-group {
    height: 43px;
    margin: 0.5rem auto;
  }
  .info-box .form-box .sex-box .el-radio-group .el-radio-button {
    flex: 1;
  }
  .info-box .form-box .sex-box .el-radio-button__inner {
    margin-left: 10px;
  }
  .info-box .birthday-box .el-form-item {
    flex: 1;
  }
  .info-box .birthday-box .el-form-item .el-form-item__content {
    width: 95%;
  }
  .info-box .birthday-box .birthday-year {
  }
  .info-box .birthday-box .birthday-month,
  .birthday-box .birthday-day {
    margin-left: 0;
  }
  .info-box .btns-box .save-btn {
    margin: 1rem auto !important;
  }
  /*  弹窗  */
  .info-box .el-dialog {
    width: 90%;
    border-radius: 1rem;
  }
}
</style>



// WEBPACK FOOTER //
// Info.vue?25514d10